import { Controller } from 'stimulus'
import Sortable from 'sortablejs'
import Rails from '@rails/ujs'

export default class extends Controller {
  static values = {
    resourceName: String,
    paramName: String,
    animation: Number,
    handle: String
  }

  initialize() {
    this.end = this.end.bind(this)
  }

  connect() {
    // Trouve le conteneur scrollable réel (pas window) pour que
    // l'auto-scroll fonctionne dans un layout flex height-screen
    const scrollEl = this._findScrollParent(this.element)

    this.sortable = new Sortable(this.element, {
      ...this.defaultOptions,
      ...this.options,
      scroll:                  scrollEl,
      scrollSensitivity:       80,   // déclenche le scroll à 80px du bord (au lieu de 30)
      scrollSpeed:             18,   // vitesse de scroll px/frame
      bubbleScroll:            true, // remonte aussi les parents scrollables
      forceAutoScrollFallback: true, // contourne le scroll natif qui ignore overflow-y:auto
    })
  }

  // Remonte le DOM pour trouver le premier ancêtre avec overflow scroll/auto
  _findScrollParent(el) {
    let node = el.parentElement
    while (node && node !== document.body) {
      const style = getComputedStyle(node)
      const overflow = style.overflow + style.overflowY
      if (/auto|scroll/.test(overflow) && node.scrollHeight > node.clientHeight) {
        return node
      }
      node = node.parentElement
    }
    return document.scrollingElement || document.documentElement
  }

  disconnect() {
    this.sortable.destroy()
    this.sortable = undefined
  }

  end({ item, newIndex }) {
    if (!item.dataset.sortableUpdateUrl || !window._rails_loaded) return

    const resourceName = this.resourceNameValue
    const paramName = this.paramNameValue || 'position'
    const param = resourceName ? `${resourceName}[${paramName}]` : paramName

    const data = new FormData()
    data.append(param, newIndex + 1)

    Rails.ajax({
      url: item.dataset.sortableUpdateUrl,
      type: 'PATCH',
      data
    })
  }

  get options() {
    return {
      animation: this.animationValue || this.defaultOptions.animation || 150,
      handle: this.handleValue || this.defaultOptions.handle || undefined,
      ghostClass: 'nl-sortable-ghost',
      dragClass:  'nl-sortable-drag',
      onStart: ({ item }) => {
        item.classList.add('nl-is-dragging')
      },
      onEnd: ({ item, newIndex }) => {
        item.classList.remove('nl-is-dragging')
        this.end({ item, newIndex })
      }
    }
  }

  get defaultOptions() {
    return {}
  }
}